// @flow
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import {
    Card,
    CardBody,
} from 'reactstrap';

import GenericTable from '../../components/GenericTable';
import { currencyFormat } from '../../helpers/formatter';
//import moment from 'moment';
//import { fetchJSON } from '../../helpers/api';

import TransactionDetails from './TransactionDetails';


class Transactions extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: this.props.data,
            //expanded: [...new Set(this.props.data.map(({ KeyField }) => KeyField))], // all expanded
            expanded: [], // all collapsed
            fromDate: this.props.fromDate,
            toDate: this.props.toDate,
            loading: this.props.loading,
            refresh: this.props.refresh
        };
    }

    componentDidUpdate(prevProps) {
        // refresh data after refresh button clicked 
        // must check props have changed (this.props.refresh !== prevProps.refresh) to avoid infinite loop
        if (this.props.refresh && this.props.refresh !== prevProps.refresh) {
            this.setState({
                data: [],
                expanded: [],
                fromDate: this.props.fromDate,
                toDate: this.props.toDate,
                loading: true,
                refresh: true
            });
        };

        if (this.props.loading !== prevProps.loading) {
            this.setState({
                data: this.props.data,
                expanded: [], // all collapsed
                loading: this.props.loading,
            });
        };

        // update data when tab changes
        if (this.props.data !== prevProps.data) {
            this.setState({
                data: this.props.data,
            });
        };

        if (this.props.fromDate && this.props.fromDate !== prevProps.fromDate) {
            this.setState({
                fromDate: this.props.fromDate,
            });
        };

        if (this.props.toDate && this.props.toDate !== prevProps.toDate) {
            this.setState({
                toDate: this.props.toDate,
            });
        };
    }



    render() {

        const expandRow = {
            renderer: (t) => (
                <TransactionDetails
                    //key={`transDetails-${index}`}
                    serialNo={t.serialNo}
                    leaseNo={t.leaseNo}
                    fromDate={this.state.fromDate}
                    toDate={this.state.toDate}
                    refresh={this.state.refresh}
                />
            ),

            showExpandColumn: true,
            onlyOneExpanding: false,
            expanded: this.state.expanded,
            expandHeaderColumnRenderer: ({ isAnyExpands }) => {
                return isAnyExpands ? <i className="dripicons-minus" /> : <i className="dripicons-plus" />;
            },
            expandColumnRenderer: ({ expanded }) => {
                return expanded ? <i className="dripicons-minus" /> : <i className="dripicons-plus" />;
            },

            onExpand: (row, isExpand) => {
                if (isExpand) {
                    let expanded = [...new Set(this.state.expanded)];
                    expanded.push(row.keyField);
                    this.setState({
                        expanded: expanded,
                    });
                }
                else {
                    // remove if exists in the array
                    this.setState({
                        expanded: [...new Set(this.state.expanded)].filter(item => item !== row.keyField),
                    });
                }
            },
            onExpandAll: (isExpandAll) => {
                if (isExpandAll) {
                    let expanded = [...new Set(this.state.data.map(({ keyField }) => keyField))];
                    this.setState({
                        expanded: expanded,
                    });
                }
                else {
                    this.setState({
                        expanded: [],
                    });
                }
            }
        };


        const columns = [
            {
                dataField: 'serialNo',
                text: 'Serial No.',
                sort: true,
            },
            {
                dataField: 'registrationNo',
                text: 'Reg No.',
                sort: true,
            },
            {
                dataField: 'leaseNo',
                text: 'Lease No',
                searchable: false,
                hidden: true
            },
            {
                dataField: 'rental',
                text: 'Rental',
                sort: true,
                headerClasses: 'numberColumn',
                classes: 'numberColumn',
                formatter: currencyFormat
            },
            {
                dataField: 'supplementaryRent',
                text: 'Supplementary Rent',
                sort: true,
                headerClasses: 'numberColumn',
                classes: 'numberColumn',
                formatter: currencyFormat
            },
            {
                dataField: 'commitmentFee',
                text: 'Commitment Fee',
                sort: true,
                headerClasses: 'numberColumn',
                classes: 'numberColumn',
                formatter: currencyFormat
            },
            {
                dataField: 'latePaymentInterest',
                text: 'Late Payment Interest',
                sort: true,
                headerClasses: 'numberColumn',
                classes: 'numberColumn',
                formatter: currencyFormat
            },
            {
                dataField: 'other',
                text: 'Other',
                sort: true,
                headerClasses: 'numberColumn',
                classes: 'numberColumn',
                formatter: currencyFormat
            },
            {
                dataField: 'total',
                text: 'Total',
                sort: true,
                headerClasses: 'numberColumn',
                classes: 'numberColumn',
                formatter: currencyFormat
            },
        ];

        const defaultSorted = [
            {
                dataField: 'serialNo',
                order: 'asc',
            },
        ];


        return (
            <React.Fragment>
                <Card className="expand-row">
                    <CardBody>
                        <React.Fragment>
                            <span className="h5">Transactions</span>
                            <GenericTable
                                columns={columns}
                                data={this.state.data}
                                keyField='keyField'
                                defaultSorted={defaultSorted}
                                loading={this.state.loading}
                                expandRow={expandRow}
                                noSearch
                                noPagination
                            />
                        </React.Fragment>
                    </CardBody>
                </Card>
            </React.Fragment>
        );
    }
}


export default withRouter(
    connect()(Transactions)
);